<template>
        <div class="loader-div" v-if="start">
            <div class="lds-spinner">
                   <section class="spinner-position"> 
                        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                   </section>
            </div>
            <p class="loader-text">İşleminiz devam ediyor.Lütfen bekleyin.</p>
        </div>
</template>



<script>
    export default {
        props:['start']
    }
</script>



<style scoped>

.loader-div {
    width: 100%;
    height: 100%;
    background-color:rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
}
.spinner-position{
    position: absolute;
    left: 40%;
    top: 30%;
}
.loader-text{
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin-top: 3rem;
    position: absolute;
}
.lds-spinner {
  display: inline-block;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 375px;
  height: 210px;
  background: #fff;
  border-radius: 15px;
  
}
.lds-spinner div {
  transform-origin: 38px 17px;
  animation: lds-spinner 1.2s linear infinite;
  
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 2px;
  height: 7px;
  border-radius: 20%;
  background: #000;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Preloader.vue